import { Injectable } from '@angular/core';
import {
  HttpClient, HttpHeaders
} from '@angular/common/http';
import { Observable, of, shareReplay, map } from 'rxjs';

import { AktualnosciListaDto } from '../modele/aktualnosci-lista-dto';

import { environment } from 'src/environments/environment';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    // 'Connection': 'keep-alive',
    // 'Response-Type': 'application/json',
    // 'Sec-Fetch-Mode': 'no-cors',
    // 'Sec-Fetch-Dest':'application/json',
    // 'Sec-Fetch-Site':'https://mapa.um.warszawa.pl',
    // 'Access-Control-Allow-Origin': '*'
  })
}

@Injectable({
  providedIn: 'root'
})
export class ControllerAktualnosciService {
  basePHAPIUrl: string = environment.basePHAPIUrl;
  constructor(private http: HttpClient) { }
  private cache$?: Observable<AktualnosciListaDto[]>;

  getArchiwum(): Observable<AktualnosciListaDto[]> {
    return this.http.get<AktualnosciListaDto[]>(this.basePHAPIUrl + '/aktualnosci/findAllArchive').pipe(
      map((aktualnosci) =>
        [...aktualnosci].sort((a, b) => {
          const timeA = a.dataUtworzenia ? new Date(a.dataUtworzenia).getTime() : 0;
          const timeB = b.dataUtworzenia ? new Date(b.dataUtworzenia).getTime() : 0;
          const valA = isNaN(timeA) ? 0 : timeA;
          const valB = isNaN(timeB) ? 0 : timeB;
          return valB - valA;
        })
      ),
      shareReplay(1)
    );
  }
  getAktualnosci(): Observable<AktualnosciListaDto[]> {
    if (!this.cache$) {
      this.cache$ = this.http.get<AktualnosciListaDto[]>(this.basePHAPIUrl + '/aktualnosci/findAll').pipe(
        map((aktualnosci) =>
          [...aktualnosci].sort((a, b) => {
            const timeA = a.dataUtworzenia ? new Date(a.dataUtworzenia).getTime() : 0;
            const timeB = b.dataUtworzenia ? new Date(b.dataUtworzenia).getTime() : 0;
            const valA = isNaN(timeA) ? 0 : timeA;
            const valB = isNaN(timeB) ? 0 : timeB;
            return valB - valA;
          })
        ),
        shareReplay(1)
      );
    }
    return this.cache$;
  }
}
